import { useNavigate } from "react-router-dom";
import { EditableText } from "../../components/EditableText/EditableText.tsx";
import { ClickableIcon } from "../../components/Icon/ClickableIcon.tsx";
import { useAppMutation } from "../../http/useAppMutation.ts";
import { HOME, WORKSPACES } from "../../routes.ts";
import { useWorkspaceUuid } from "../hooks/useWorkspaceUuid.ts";
import { BOARD_NAME_PLACEHOLDER } from "../types.ts";
import { HorizontalLayout } from "./components/Layout/HorizontalLayout.tsx";
import { useBoard } from "./hooks/useBoard.ts";

export const Header = () => {
  const navigate = useNavigate();
  const workspaceUuid = useWorkspaceUuid();
  const { board } = useBoard();

  const { mutation: updateBoardMutation } = useAppMutation({
    path: "boards/update",
    invalidate: [`boards/${board.uuid}`],
  });

  const handleUpdateBoardName = (newName: string) => {
    updateBoardMutation.mutate({
      uuid: board.uuid,
      name: newName,
    });
  };

  return (
    <HorizontalLayout
      leftComponent={
        <div className="flex-row-center border-b pl-500 py-200">
          <ClickableIcon
            name="Home"
            size="md"
            variant="tertiary"
            onClick={() => navigate(`${WORKSPACES}/${workspaceUuid}/${HOME}`)}
          />
          <div className="flex-fill flex-row-center px-400 py-100">
            <EditableText
              value={board.name || BOARD_NAME_PLACEHOLDER}
              placeholder={BOARD_NAME_PLACEHOLDER}
              isLoading={updateBoardMutation.isLoading}
              className="w-full"
              textClassName="text-primary label-lg-semibold"
              onSave={handleUpdateBoardName}
            />
          </div>
        </div>
      }
    >
      <div className="h-full flex-row-reverse border-b-025 px-200" />
    </HorizontalLayout>
  );
};
